import {
  arrayOfParam,
  numberParam,
  stringParam,
  useDebouncedCallback,
  useQueryParams,
} from '@piccolohealth/ui';
import { PaginationFilter } from '../graphql/fetcher';

const DEFAULT_PAGE_NUMBER = 0;
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_CONTENT_FILTER = '';
const DEFAULT_LABEL_FILTER: string[] = [];

export interface ParticipantNotesFilter extends PaginationFilter {
  contentFilter: string;
  onContentFilter: (content: string) => void;
  labelFilter: string[] | undefined;
  onLabelFilter: (labels: string[]) => void;
}

export const useParticipantNotesFilter: () => ParticipantNotesFilter = () => {
  const [params, setParams] = useQueryParams({
    page: numberParam,
    pageSize: numberParam,
    content: stringParam,
    label: arrayOfParam(stringParam, { delimiter: ',' }),
  });

  const setCurrentPageNumber = (value: number) =>
    setParams({
      page: value,
    });

  const setPageSize = (value: number) =>
    setParams({
      pageSize: value,
      page: 0,
    });

  const showTotal = (total: number, range: [number, number]) =>
    `${range[0]}-${range[1]} of ${total} notes`;

  const onContentFilter = useDebouncedCallback(
    (value: string) => setParams({ content: value, page: 0 }),
    1000,
  );

  const onLabelFilter = (value?: string[]) =>
    setParams({
      label: value,
      page: 0,
    });

  return {
    pageSizeOptions: [10, 20, 50, 100],
    pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE,
    currentPageNumber: params.page ?? DEFAULT_PAGE_NUMBER,
    showTotal,
    setPageSize,
    setCurrentPageNumber,
    contentFilter: params.content ?? DEFAULT_CONTENT_FILTER,
    onContentFilter,
    labelFilter: params.label ?? DEFAULT_LABEL_FILTER,
    onLabelFilter,
  };
};
